module.exports = __webpack_public_path__ + "img/jr.1bda79a1.png";